import React from 'react';

import './App.css';
import './styles/game.scss';
import './styles/index.scss';
import { API } from '@pbl/pbl-react-core/lib/services';
import { addRequestTransform, addResponseTransform, apiConfiguration } from './utils/apiConfig';
import AppSpinner from './app-spinner/AppSpinner';

interface AppState {}

class App extends React.Component<{}, AppState> {
  componentDidMount() {
    API.setup(apiConfiguration, { addRequestTransform, addResponseTransform });
  }

  preventBubblingToElement(event) {
    event.stopPropagation();
    return false;
  }

  validateInput(event) {
    let key = event.keyCode || event.which;
    // Handle paste
    if (event.type === 'paste') {
      key = event.clipboardData.getData('text/plain');
    } else {
      // Handle key press
      key = String.fromCharCode(key);
    }
    const regex = /^[0-9]+$/;

    if (!regex.test(key) || event.target?.value?.length === 6 || key === 'e') {
      event.returnValue = false;
      if (event.preventDefault) event.preventDefault();
      return false;
    }
  }

  render() {
    return (
      <>
        <div id="ftf-message-popup" className={'ftf-input-popup'} onClick={this.preventBubblingToElement}>
          {/* <div className={'overlay'}>overlay</div> */}
          <div id="ftf-message-container">
            <label id="ftf-message-label" style={{ fontFamily: 'Jost' }} className={'ftf-label'}>
              message
            </label>
          </div>

          <button className={'ftf-message-btn'} type={'button'} id={'ftf-message-submit'} />
        </div>
        <div id="ftf-spinner">
          <AppSpinner />
        </div>
        <div id="ftf-input-popup" style={{ fontFamily: 'Jost' }} className={'ftf-input-popup'} onClick={this.preventBubblingToElement}>
          {/* <div className={'overlay'}>overlay</div> */}
          <div id="ftf-draw-container">
            <label id="ftf-label" style={{ fontFamily: 'Jost' }} className={'ftf-label'}>
              DRAWING ID
            </label>
            <input
              type="number"
              className={'text-input'}
              id={'ftf-input-draw-id'}
              max={999999}
              min={0}
              maxLength={6}
              name={'drawNumber'}
              autoComplete={'off'}
              onPaste={this.validateInput}
              onKeyPress={this.validateInput}
              style={{ fontFamily: 'Jost' }}
            />
          </div>
          <button className={'ftf-popup-btn'} type={'button'} id={'ftf-popup-submit'} />
        </div>
      </>
    );
  }
}

export default App;
